import { IWithdrawDetailsV2 } from '@/modules/transaction/services/product-withdraw';

export enum EProductTypes {
  FIXED_INCOME = 'fixed-income',
  GOVERNMENT_BOND = 'government-bond',
  FUNDS = 'funds'
}

export function errorText(
  data: IWithdrawDetailsV2,
  inputValue: number,
  productType: string
) {
  const {
    minimumRedemption,
    availableToRedemption,
    minimumToStay,
    inRedemption
  } = data;

  const valueGreaterThanZero = inputValue > 0;
  const valueLesserThanAvailable = inputValue < availableToRedemption.value;
  const valueLesserThanMinimumToStay =
    availableToRedemption.value - inputValue < minimumToStay.value;

  if (inputValue === availableToRedemption.value) {
    return '';
  }

  if (valueGreaterThanZero && inputValue < minimumRedemption.value) {
    return `O valor mínimo para resgate é de ${minimumRedemption.formatted}. Escolha um valor maior ou igual para resgatar.`;
  }

  if (inputValue > availableToRedemption.value) {
    if (inRedemption.value) {
      return `Você só pode resgatar até ${availableToRedemption.formatted} porque parte do valor está em resgate.`;
    }

    return 'Valor maior que o saldo disponível';
  }

  if (productType === EProductTypes.FUNDS && minimumToStay.value) {
    if (
      valueGreaterThanZero &&
      valueLesserThanAvailable &&
      valueLesserThanMinimumToStay
    ) {
      return 'O valor deve respeitar o mínimo de permanência';
    }
  }

  return '';
}

export function listDetails(
  data: IWithdrawDetailsV2,
  netBalance: string,
  productType: string,
  loading: boolean
) {
  const { minimumRedemption, minimumToStay, totalRedemptionPeriod } = data;

  const list = [
    {
      label: 'Valor líquido',
      value: netBalance,
      show: true,
      loading
    },
    {
      label: minimumRedemption.label,
      value: minimumRedemption.formatted,
      show: Boolean(minimumRedemption),
      loading: false
    },
    {
      label: minimumToStay.label || '',
      value: minimumToStay.formatted || '',
      show: productType === EProductTypes.FUNDS,
      loading: false
    },
    {
      label: totalRedemptionPeriod.label,
      value: totalRedemptionPeriod.value,
      show: Boolean(totalRedemptionPeriod),
      loading: false
    }
  ];

  return list.filter(item => item.show);
}
